import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import { toFormat } from 'core/classes/helpers/DateHelper'

import { CommitmentStatusIcon } from '../editors/CommitmentStatusIcon'

import { CommitmentStatuses, ICommitmentEditorItem } from './models'

import styles from './CommitmentItemStatus.module.scss'

const defaultCommitmentStatusColor = '#000000'

type Props = {
  commitmentItem: ICommitmentEditorItem
  openChangesLog: () => void
}

export function CommitmentItemStatus({ commitmentItem, openChangesLog }: Props) {
  return (
    <Flex className={styles.root} justifyContent={'space-between'} alignItems={'center'}>
      <Flex flexGrow={1} alignItems={'center'}>
        <div className={styles.label}>
          <Translation text="partnercommitment-status" span />
        </div>

        <CommitmentStatusIcon
          className={styles.icon}
          size="small"
          color={commitmentItem.CommitmentStatusColor}
          icon={`${commitmentItem.CommitmentStatusIcon}`}
        />

        <div
          className={styles.status}
          style={{
            color: commitmentItem.CommitmentStatusColor || defaultCommitmentStatusColor,
          }}
        >
          <Translation text={commitmentItem.CommitmentStatusKey} span />
          &nbsp;
        </div>
        <RenderWhen condition={Boolean(commitmentItem?.EmailSentDate)}>
          <Translation
            span
            text="jbp-commitment-email-sent-date"
            replaceParams={[
              {
                key: '[date]',
                value: toFormat(commitmentItem?.EmailSentDate || '', 'DD MMM YYYY HH:mm'),
              },
            ]}
          />
        </RenderWhen>
      </Flex>

      <RenderWhen condition={commitmentItem.CommitmentStatusKey === CommitmentStatuses.Dropped}>
        <Button variant={'text'} onClick={openChangesLog} className={styles.details}>
          <Translation text={'jbp-commitment-changes-details'} />
        </Button>
      </RenderWhen>
    </Flex>
  )
}
